import React from 'react'
import { Toast, ToastBody } from 'reactstrap'
import styles from './toastMessage.module.css'

function ToastMessage({ isToastOpen = false, toastType = '', toastMessage = '' }) {
    return (
        <div className="d-flex justify-content-center text-white fw-lighter border-0 text-center">
            <Toast
                fade
                isOpen={isToastOpen}
                className={`${styles.toast} ${
                    toastType.toLowerCase() === 'success'
                        ? styles.successToast
                        : styles.dangerToast
                }
                `}
            >
                <ToastBody>{toastMessage}</ToastBody>
            </Toast>
        </div>
    )
}

export default ToastMessage
